export default __webpack_public_path__ + "static/media/Standard29.c64b8453.png";